/**
 * Platform import presets (TMMAPP-0107, adopts TMMAPI-0149 / MM-D-121) — wire types from
 * `src/api/generated/`. Members list the ACTIVE presets for the import Format select.
 * Preview and commit take `presetId`; the mapping is kept so Configuration can show it.
 */
import { request } from './client';
import type { ImportPresetOption as WirePreset } from './generated';
import { normalizeProposedMapping, type ImportProposedMapping } from './imports';

export interface ImportPreset {
  id: number;
  name: string;
  institution: string | null;
  /** The preset's mapping as a proposal (source PRESET). */
  mapping: ImportProposedMapping;
  delimiter: string;
  encoding: string;
}

/**
 * The preset's mapping as a proposal: source PRESET, no AI confidence, no notes. An empty
 * institution is null; the column map keeps an unmapped field null.
 */
export function normalizeImportPreset(w: WirePreset): ImportPreset {
  return {
    id: w.id,
    name: w.name,
    institution: w.institution !== undefined && w.institution.length > 0 ? w.institution : null,
    mapping: {
      ...normalizeProposedMapping({ ...w, source: 'PRESET', confidence: 0, notes: [] }),
      confidence: null,
    },
    delimiter: w.delimiter,
    encoding: w.encoding,
  };
}

export const importPresetsApi = {
  /** GET /v1/import-presets — the ACTIVE presets, identical for every tenant. */
  async list(): Promise<ImportPreset[]> {
    const wire = await request<WirePreset[]>('GET', '/v1/import-presets');
    return wire.map(normalizeImportPreset);
  },
};
